module.exports = __webpack_public_path__ + "img/rotate-right.006d02e5.svg";